<template>
  <div>
    <!-- <PoolPlayAddGameModal :isEditingGame="isEditingGame" :association_id="association_id" :eventId="eventId"
            @RefreshPoolPlayGames="getPoolPlayGames" :field="selectedFieldForModal" :time="selectedTimeForModal"
            :date="selectedDateForModal" :gameType="gameType" :totalGames="totalGames"
            :selectedGameName="selectedGameName" :team1-id="team1Id" :team2-id="team2Id" :game_id="game_id"
            :umpireId="umpireId" /> -->
    <div class="sub-header-container">
      <!-- <div class="actions-container">
                <div class="opt mt-0 position-relative cursor-pointer">
                    <img src="../../assets/Svg/ellipse.svg" alt="" />
                </div>
            </div> -->

      <div class="play2-loader" v-if="showEventHeadingLoader">
        <content-placeholders :rounded="true">
          <content-placeholders-text :lines="2" />
        </content-placeholders>
      </div>

      <div class="pool-play-event-heading" v-else>
        <div class="pool-play-event-name">{{ eventName }}</div>
        <div class="pool-play-event-date" v-if="events && events.exactStartDate && events.exactEndDate">
          {{ formatDateRange(events.exactStartDate, events.exactEndDate) }}
        </div>
      </div>

      <div class="go-listing-div" @click="goEventListing">
        <div class="go-listing-img">
          <img src="../../assets/Svg/close-editor.svg" alt="" />
        </div>
        <span>Close MatchGeni</span>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 col-md-8">
        <div class="products-list-shim" v-if="bracketsLoader">
          <content-placeholders :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
          <content-placeholders class="mt-3" :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
          <content-placeholders class="mt-3" :rounded="true">
            <content-placeholders-img />
            <content-placeholders-heading />
          </content-placeholders>
        </div>
        <div class="brackets-section-div" v-else>
          <div class="division-details-div">
            <div class="selected-division-container">
              <button class="btn pl-0" @click="handleBackClick">
                <img src="../../assets/Svg//back-arrow.svg" alt="">
              </button>
              <div>
                <div class="selected-division-name">
                  {{ selectedTournamentName }}
                </div>
                <div class="selected-division-date"
                  v-if="selectedTournament && selectedTournament.exactStartDate && selectedTournament.exactEndDate">
                  {{ formatDateRange(selectedTournament.exactStartDate, selectedTournament.exactEndDate) }}
                </div>
              </div>
            </div>
            <div class="add-bracket-pagination-div">
              <div class="add-bracket-btn" @click="addBracket">
                <button>
                  <!-- <div v-if="isGenerating">
                          <img src="../../assets/loader.gif" alt="" />
                      </div> -->
                  <span>
                    Add Bracket
                  </span>
                </button>
              </div>
              <div v-if="bracketCount > 0" class="bracket-pagination">
                <div class="add-bracket-btn">
                  <button @click="goToPreviousBracket" :disabled="activeBracketIndex === 0">
                    <img src="../../assets/Svg/pagination-left.svg" />
                  </button>
                </div>

                <span>Bracket {{ activeBracketIndex + 1 }} of {{ bracketCount }}</span>

                <div class="add-bracket-btn">
                  <button @click="goToNextBracket" :disabled="activeBracketIndex >= bracketCount - 1">
                    <img src="../../assets/Svg/pagination-right.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="bracket-details-div">
            <div class="bracket-name-count-div">
              <div class="bracket-name">{{ bracketName }}</div>
              <div class="teams-count-format">{{ teamCounts }} Teams - {{ bracketFormat }}</div>
            </div>
            <div @click="editBracket" class="cursor-pointer">
              <img src="../../assets/Svg/edit-2.svg" alt="">
            </div>
          </div>
          <div class="tip-wrapper bracket-play-tip-wrapper">
            <span>Smart Bracket Scheduling</span>
            <p>Let the system automatically schedule game time slots, and field assignments based on your bracket
              structure. This saves time and ensures fair and conflict-free scheduling. You can review and make
              adjustments after the schedule is generated.</p>
            <div class="d-flex align-items-center mt-2" style="gap: 20px;">
              <!-- <button class="btn btn-primary">
            <div v-if="isLoadingArray[0]" style="width: 24px; height: 24px; position: relative;">
              <img src="../../assets/loader.gif" alt="" style="width: 100%;"/>
            </div>
            <div v-else>Start Bracket Play</div>
          </button> -->
          <div v-if="scheduleLoader" class="lds-dual-ring"></div>
              <small v-else class="cursor-pointer" @click="scheduleBracketGames">Run Scheduler</small>
            </div>
          </div>
          <!-- Single Elimination Bracket Display -->
          <div v-if="bracketType === 'single'" class="bracket-container">
            <div class="bracket-section winner-section" :style="{ height: `${winnerBracketHeight}px` }">
              <div class="winner-bracket-label">Winner Bracket</div>
              <div class="bracket-rounds-container">
                <div v-for="(round, rIndex) in singleEliminationRounds" :key="rIndex" class="bracket-round">
                  <div v-for="(match, mIndex) in round" :key="mIndex" class="bracket-match" :style="{
                    top: `${match.top}px`,
                    height: `${match.matchHeight}px`,
                    position: 'absolute'
                  }" draggable="true" @dragstart="onDragStart(match, $event)">
                    <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                    <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                      {{ match.originalGame.assignedTime }}
                    </div>
                    <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                    <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                      {{ formatAssignedDate(match.originalGame.assignedDate) }}
                    </div>
                    <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                      {{ match.originalGame.assignedFieldName }}
                    </div>
                    <div class="game-container">
                      <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <span v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </span>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <span v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </span>
</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Double Elimination Bracket Display -->
          <div v-if="bracketType === 'double'" class="double-bracket-container">
            <!-- Main Bracket Container -->
            <div class="main-bracket-wrapper">
              <!-- Winner Bracket Section -->
              <div class="bracket-section winner-section" :style="{ height: `${winnerBracketHeight}px` }">
                <div class="winner-bracket-label">Winner Bracket</div>
                <div class="bracket-rounds-container">
                  <div v-for="(round, rIndex) in winnerBracketRounds" :key="`winner-${rIndex}`" class="bracket-round">
                    <div v-for="(match, mIndex) in round" :key="`winner-${rIndex}-${mIndex}`" class="bracket-match"
                      :style="{
                        top: `${match.top}px`,
                        height: `${match.matchHeight}px`,
                        position: 'absolute'
                      }" draggable="true" @dragstart="onDragStart(match, $event)">
                      <!-- Game Info Overlays -->
                      <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                      <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                        {{ match.originalGame.assignedTime }}
                      </div>
                      <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                      <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                        {{ formatAssignedDate(match.originalGame.assignedDate) }}
                      </div>
                      <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                        {{ match.originalGame.assignedFieldName }}
                      </div>
                      <div class="game-container">
                        <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Grand Final Section -->
              <div class="bracket-section grand-final-section" :style="{ height: `${winnerBracketHeight}px` }">
                <div class="bracket-rounds-container">
                  <div class="bracket-round">
                    <div v-for="(match, mIndex) in grandFinalRounds" :key="`final-${mIndex}`"
                      class="bracket-match final-match" :style="{
                        top: `${match.top}px`,
                        height: `${match.matchHeight}px`,
                        position: 'absolute'
                      }" draggable="true" @dragstart="onDragStart(match, $event)">
                      <!-- Game Info Overlays -->
                      <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                      <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                        {{ match.originalGame.assignedTime }}
                      </div>
                      <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                      <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                        {{ formatAssignedDate(match.originalGame.assignedDate) }}
                      </div>
                      <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                        {{ match.originalGame.assignedFieldName }}
                      </div>
                      <div class="game-container grand-final-match">
                        <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="main-bracket-wrapper">
              <!-- Loser Bracket Section -->
              <div class="bracket-section loser-section" :style="{ height: `${loserBracketHeight}px` }">
                <div class="loser-bracket-label">Loser Bracket</div>
                <div class="bracket-rounds-container">
                  <div v-for="(round, rIndex) in loserBracketRounds" :key="`loser-${rIndex}`" class="bracket-round">
                    <div v-for="(match, mIndex) in round" :key="`loser-${rIndex}-${mIndex}`" class="bracket-match"
                      :style="{
                        top: `${match.top}px`,
                        height: `${match.matchHeight}px`,
                        position: 'absolute'
                      }" draggable="true" @dragstart="onDragStart(match, $event)">
                      <!-- Game Info Overlays -->
                      <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                      <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                        {{ match.originalGame.assignedTime }}
                      </div>
                      <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                      <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                        {{ formatAssignedDate(match.originalGame.assignedDate) }}
                      </div>
                      <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                        {{ match.originalGame.assignedFieldName }}
                      </div>
                      <div class="game-container loser-match">
                        <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div v-if="showFieldsLoader">
          <div class="products-list-shim bordered-loader m-3">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
              <content-placeholders-img />
              <content-placeholders-heading />
              <content-placeholders-img />
            </content-placeholders>
          </div>
        </div>
        <div v-if="scheduleTables.length > 0 && !showFieldsLoader" class="schedule-tables-container mt-3">
          <div v-for="(table, tableIndex) in scheduleTables" :key="tableIndex" class="mb-4">
            <div :ref="'table-' + getDateForComparison(table.date)">
              <h5 class="field-date mb-3">{{ table.formattedDate }}</h5>
              <div class="pool-table-container">
                <table class="schedule-table">
                  <thead>
                    <tr>
                      <th class="field-header">Time</th>
                      <th v-for="field in table.fields" :key="field.id" class="field-header">
                        {{ field.field_name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(timeSlot, timeIndex) in table.timeSlots" :key="timeIndex">
                      <td class="field-cell">
                        <strong>{{ timeSlot.time }}</strong>
                      </td>
                      <td v-for="field in table.fields" :key="field.id" class="field-cell" @dragover.prevent
                        @drop="handleDrop(field, timeSlot, table.date, $event)" :class="{
                          'assigned': getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)),
                          'invalid': !isDateWithinTournamentRange(table.date),
                          'available': !getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)) && isDateWithinTournamentRange(table.date),
                          'current-division': getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))?.division_id === selectedTournament.id,
                          'other-division': getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))?.division_id !== selectedTournament.id
                        }" :style="getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date))
                          ? getDivisionStyle(getAssignedGame(field.id, timeSlot.time, getDateForComparison(table.date)).division)
                          : {}" @click="handleAvailableClick(field, timeSlot.time, table.date, false)">

                        <!-- Assigned Game (shown regardless of date validity) -->
                        <div v-if="assignedGameFor(field.id, timeSlot.time, table.date)" class="assigned-game-container"
                          :title="assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id ? 'Drag this game' : ''"
                          :draggable="assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id"
                          @dragstart="onDragStart(assignedGameFor(field.id, timeSlot.time, table.date), $event)" :style="{
                            cursor: assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id ? 'grab' : 'not-allowed',
                            userSelect: assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id ? 'auto' : 'none'
                          }">
                          <div class="game-info">
                            <div class="teams-names teams-names2">
                              <template v-if="assignedGameFor(field.id, timeSlot.time, table.date)">
                                <template v-if="assignedGameFor(field.id, timeSlot.time, table.date).game_type === 2">
                                  #{{ assignedGameFor(field.id, timeSlot.time,
                                    table.date).game_name || 'Unnamed Game' }}
                                </template>
                                <template v-else>
                                  #{{ assignedGameFor(field.id, timeSlot.time,
                                    table.date)?.teamA_data?.team_sr_no || 'TBD' }}
                                  <span class="vs-text">vs</span>
                                  #{{ assignedGameFor(field.id, timeSlot.time,
                                    table.date)?.teamB_data?.team_sr_no || 'TBD' }}
                                </template>
                              </template>

                            </div>
                            <div class="division-names">
                              {{ assignedGameFor(field.id, timeSlot.time,
                                table.date)?.division }}
                            </div>
                          </div>

                          <button
                            v-if="assignedGameFor(field.id, timeSlot.time, table.date).division_id == selectedTournament.id"
                            class="btn btn-sm unlink-btn mt-1"
                            @click.stop="unlinkGame(assignedGameFor(field.id, timeSlot.time, table.date))"
                            title="Unlink this game">
                            Unlink
                          </button>
                        </div>

                        <!-- If no assigned game but date is valid -->
                        <!-- <div v-else-if="isDateWithinTournamentRange(table.date)"
                                                class="availability-status available">
                                                Available
                                            </div> -->

                        <div v-else-if="isDateWithinTournamentRange(table.date)" class="availability-status available">
                          <span class="available-text available-text2">Available</span>
                          <!-- <span class="add-game-hover-text">
                            <div>
                              <img src="../../assets/Svg/add-team.svg" alt="">
                            </div>
                            Add Game
                          </span> -->
                        </div>

                        <!-- If no assigned game and date is invalid -->
                        <div v-else class="availability-status invalid">
                          Invalid date for <br> Division
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div v-if="
          (!scheduleTables || scheduleTables.length === 0) && showFieldsLoader === 0" class="no-event-wrap">
          <img src="../../assets/Svg/no-data.svg" alt />
          <p class="header">No field found.</p>
          <p class="info">There are no field against parks to display.</p>
        </div>
      </div>
    </div>
    <EditBracketModal @RefreshBracketOnEdit="onRefreshBracketOnEdit" />
    <AddBracketModal @RefreshBracketOnAdd="onRefreshBracketOnAdd" />

  </div>
</template>

<script>
import axios from "axios";
import AddBracketModal from "./AddBracketModal.vue"
import EditBracketModal from "./EditBracketModal.vue"
// import PoolPlayAddGameModal from "../../components/PoolPlayGenerator/PoolPlayAddGameModal.vue";

export default {
  name: "BracketDisplay",
  components: {
    AddBracketModal,
    EditBracketModal,
    // PoolPlayAddGameModal,
  },
  data() {
    return {
      bracketGames: [],
      bracketType: '', // 'single' or 'double'
      singleEliminationRounds: [],
      winnerBracketRounds: [],
      loserBracketRounds: [],
      grandFinalRounds: [],
      events: {},
      eventName: "",
      showEventHeadingLoader: 0,
      bracketsLoader: 0,
      eventGuid: "",
      selectedTournament: {},
      selectedTournamentName: "",
      bracketName: "",
      bracketDescription: "",
      teamCounts: "",
      bracketFormat: "",
      showFieldsLoader: 1,
      searchQuery: '',
      eventId: null,
      startDate: null,
      endDate: null,
      startTime: "08:00 AM",
      endTime: "05:00 PM",
      tournament_time: "",
      scheduleData: [],
      fieldAssignments: [],
      divisionColorMap: {},
      draggedGame: null,
      tournamentTeams: [],
      pools: [],
      bracketTeams: [],
      bracketCount: 0,
      activeBracketIndex: 0,
      showBracketLoader: 0,
      bracketGuid: "",
      bracketId: 0,
      // Add height tracking
      winnerBracketHeight: 0,
      loserBracketHeight: 0,

      allDay: false,
      scheduleLoader: 0
    };
  },
  async mounted() {
    await this.getBracketData();
    await this.TournamentsDetailData();
    this.getParkField();
    this.getAllBrackets();
    await this.getEventGamesSchedule();
    this.getTournamentTeams();
  },
  watch: {
    '$route.params.id': {
      handler(newGuid) {
        const index = this.brackets?.findIndex(b => b.guid === newGuid);
        this.activeBracketIndex = index !== -1 ? index : 0;
      },
      immediate: true
    }
  },
  computed: {
    assignedGamesMap() {
    const map = {};
    console.log('=== assignedGamesMap RECALCULATING ===');
    
    this.scheduleData.forEach(game => {
      if (game.assignedFieldId && game.assignedTime && game.assignedDate) {
        // Check the types of the values being used for the key
        console.log('Game scheduling data:', {
          fieldId: game.assignedFieldId,
          fieldIdType: typeof game.assignedFieldId,
          time: game.assignedTime,
          timeType: typeof game.assignedTime,
          date: game.assignedDate,
          dateType: typeof game.assignedDate
        });
        
        const key = `${game.assignedFieldId}-${game.assignedTime}-${game.assignedDate}`;
        console.log('Generated key:', key);
        map[key] = game;
      }
    });
    
    console.log('Final map keys:', Object.keys(map));
    return map;
  },
    scheduleTables() {
      if (!this.startDate || !this.endDate || !this.startTime || !this.endTime || !this.tournament_time || this.allFields.length === 0) {
        return [];
      }

      const tables = [];
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);

      for (let date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
        const currentDate = new Date(date);
        const timeSlots = this.generateTimeSlots(this.startTime, this.tournament_time, this.endTime);

        tables.push({
          date: currentDate,
          formattedDate: this.formatTableDate(currentDate),
          timeSlots,
          fields: this.selectedFields,
        });
      }

      return tables;
    },
  },
  methods: {
    onRefreshBracketOnEdit() {
      this.getBracketData();
    },
    onRefreshBracketOnAdd() {
      this.getAllBrackets()
      this.getBracketData();
    },
    getAllBrackets() {
      var formData = new FormData();
      formData.append("tournament_guid", this.selectedTournament.guid);
      formData.append("association_id", this.association_id);

      this.showBracketLoader = 1;
      return axios
        .post(
          process.env.VUE_APP_API_URL +
          "tournaments/brackets/getTournamentBrackets",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.brackets = response.data.data;
            this.bracketCount = this.brackets.length;
            var url = window.location.pathname;
            var segment_array = url.split("/");
            var activeBracketGuid = segment_array.pop();
            // Find index
            const activeIndex = this.brackets.findIndex(b => b.guid === activeBracketGuid);

            // Set active bracket index (add this to your component's data())
            this.activeBracketIndex = activeIndex !== -1 ? activeIndex : 0;
            this.showBracketLoader = 0;
          } else {
            this.showBracketLoader = 0;
          }
        });
    },
    goToPreviousBracket() {
      if (this.activeBracketIndex > 0) {
        const newGuid = this.brackets[this.activeBracketIndex - 1].guid;
        if (newGuid !== this.$route.params.bracket_guid) {
          this.$router.replace({
            name: this.$route.name,
            params: {
              id: newGuid
            }
          })
          this.getBracketData();
        }
      }
    },

    goToNextBracket() {
      if (this.activeBracketIndex < this.brackets.length - 1) {
        const newGuid = this.brackets[this.activeBracketIndex + 1].guid;

        if (newGuid !== this.$route.params.bracket_guid) {
          this.$router.replace({
            name: this.$route.name,
            params: {
              id: newGuid
            }
          })
          this.getBracketData();
        }
      }
    },
    scheduleBracketGames() {
    this.scheduleLoader = 1;
  var formData = new FormData();
  formData.append("bracket_id", this.bracketId);
  formData.append("event_id", this.eventId);

  return axios
    .post(
      process.env.VUE_APP_API_URL +
      "tournaments/brackets/autoScheduleGames",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.data.statusCode == 200) {
        this.scheduleLoader = 0;
        
        // Update local data with the scheduled games from API response
        if (response.data.data && Array.isArray(response.data.data)) {
          this.updateLocalGamesWithApiData(response.data.data);
        }
        
        // Force Vue to completely re-render by creating new array reference
        this.scheduleData = [...this.scheduleData];
        
        // Force Vue to update the view
        this.$forceUpdate();
        this.$alert(response.data.message, "Success");
        
      } else {
        this.scheduleLoader = 0;
      }
    })
    .catch((error) => {
      console.error("Error scheduling bracket games:", error);
      this.scheduleLoader = 0;
    });
},

// Helper method to update local games with API response data
// Add this method to convert API time format to template format
// Improved time conversion with more robust handling
convertApiTimeToTemplateFormat(apiTime) {
  if (!apiTime) return '';
  
  try {
    // Handle various time formats
    let hourNum, minutes;
    
    if (apiTime.includes('AM') || apiTime.includes('PM')) {
      // Already in 12-hour format, just ensure proper formatting
      const [timePart, period] = apiTime.split(' ');
      [hourNum, minutes] = timePart.split(':').map(part => parseInt(part));
      
      // Handle 12-hour conversion properly
      if (period === 'PM' && hourNum !== 12) hourNum += 12;
      if (period === 'AM' && hourNum === 12) hourNum = 0;
    } else {
      // Handle 24-hour format (with or without seconds)
      const timeParts = apiTime.split(':');
      hourNum = parseInt(timeParts[0]);
      minutes = parseInt(timeParts[1] || '0');
    }
    
    // Convert back to 12-hour format for template
    let hour12 = hourNum % 12;
    if (hour12 === 0) hour12 = 12;
    const period = hourNum >= 12 ? 'PM' : 'AM';
    
    return `${hour12}:${minutes.toString().padStart(2, '0')} ${period}`;
  } catch (error) {
    console.error('Error converting time:', apiTime, error);
    return apiTime; // Return original as fallback
  }
},

// Also update your getAssignedGame to be more flexible
getAssignedGame(fieldId, time, date) {
  // Normalize fieldId to number
  const numFieldId = typeof fieldId === 'string' ? parseInt(fieldId) : fieldId;
  const normalizedDate = this.getDateForComparison(date);
  
  // First try exact match
  const exactKey = `${numFieldId}-${time}-${normalizedDate}`;
  const exactMatch = this.assignedGamesMap[exactKey];
  if (exactMatch) return exactMatch;
  
  // If no exact match, try flexible matching
  const possibleTimes = this.generatePossibleTimeVariations(time);
  
  for (const possibleTime of possibleTimes) {
    const possibleKey = `${numFieldId}-${possibleTime}-${normalizedDate}`;
    const possibleMatch = this.assignedGamesMap[possibleKey];
    if (possibleMatch) {
      console.log('Found flexible match:', {original: time, matched: possibleTime});
      return possibleMatch;
    }
  }
  
  return null;
},

// Generate all possible time format variations
generatePossibleTimeVariations(time) {
  const variations = new Set([time]);
  
  try {
    // If it's already in 12-hour format, generate 24-hour variations
    if (time.includes('AM') || time.includes('PM')) {
      const [timePart, period] = time.split(' ');
      let [hours, minutes] = timePart.split(':').map(part => parseInt(part));
      
      let hour24 = hours;
      if (period === 'PM' && hours !== 12) hour24 += 12;
      if (period === 'AM' && hours === 12) hour24 = 0;
      
      // 24-hour with seconds
      variations.add(`${hour24.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`);
      // 24-hour without seconds
      variations.add(`${hour24.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`);
    } 
    // If it's in 24-hour format, generate 12-hour variations
    else if (time.includes(':')) {
      const timeParts = time.split(':');
      const hour24 = parseInt(timeParts[0]);
      const minutes = parseInt(timeParts[1] || '0');
      
      let hour12 = hour24 % 12;
      if (hour12 === 0) hour12 = 12;
      const period = hour24 >= 12 ? 'PM' : 'AM';
      
      // 12-hour format
      variations.add(`${hour12}:${minutes.toString().padStart(2, '0')} ${period}`);
      variations.add(`${hour12}:${minutes} ${period}`);
    }
  } catch (error) {
    console.error('Error generating time variations:', error);
  }
  
  return Array.from(variations);
},

// Update your updateLocalGamesWithApiData method
updateLocalGamesWithApiData(apiGames) {
  if (!Array.isArray(apiGames)) return;

  console.log("Updating games with API data:", apiGames);

  // Clear all existing field assignments for this tournament/bracket first
  this.fieldAssignments = this.fieldAssignments.filter(
    assignment => assignment.game.event_id !== this.eventId
  );

  apiGames.forEach(apiGame => {
    // Find the game in scheduleData by matching IDs
    const gameIndex = this.scheduleData.findIndex(
      game => game.db_id === apiGame.id || game.id === apiGame.id
    );

    if (gameIndex !== -1) {
      const game = this.scheduleData[gameIndex];
      
      // Format the date properly (same as drag & drop uses)
      const formattedDate = this.getDateForComparison(apiGame.start_date);
      
      // Convert API time to template format
      const templateTime = this.convertApiTimeToTemplateFormat(apiGame.start_time);
      
      console.log(`Updating game ${apiGame.id} with scheduling info:`, {
        field_id: apiGame.field_id,
        api_time: apiGame.start_time,
        template_time: templateTime,
        formattedDate: formattedDate
      });
      
      // Find field name from your fields data
      const field = this.allFields.find(f => f.id === apiGame.field_id);
      
      // Create updated game object - this ensures Vue reactivity
      const updatedGame = {
        ...game,
        assignedFieldId: apiGame.field_id,
        assignedTime: templateTime, // Use the converted time!
        assignedDate: formattedDate,
        assignedFieldName: field ? field.field_name : 'Unknown Field'
      };
      
      // Replace the entire game object in scheduleData to trigger reactivity
      this.$set(this.scheduleData, gameIndex, updatedGame);

      // Add new field assignment if scheduling info exists
      if (apiGame.field_id && apiGame.start_time && apiGame.start_date) {
        const fieldAssignment = {
          fieldId: apiGame.field_id,
          fieldName: field ? field.field_name : 'Unknown Field',
          time: templateTime, // Use the converted time!
          date: formattedDate,
          game: updatedGame,
        };
        
        this.fieldAssignments.push(fieldAssignment);
        
        console.log(`Added field assignment for game ${apiGame.id}:`, fieldAssignment);
        
        // TEST: Check if the converted time matches
        this.testTimeConversion(apiGame.start_time, templateTime);
      }

      // Update the game in bracket display
      this.updateBracketGameDisplay(updatedGame);
    }
  });

  console.log("Final Updated scheduleData:", this.scheduleData);
  
  // Force a complete re-render
  this.$nextTick(() => {
    this.$forceUpdate();
  });
},

// Add this test method
testTimeConversion(apiTime, templateTime) {
  console.log('=== TIME CONVERSION TEST ===');
  console.log('API Time:', apiTime);
  console.log('Converted Template Time:', templateTime);
  
  // Test if this time exists in the schedule tables
  const timeExists = this.scheduleTables.some(table => 
    table.timeSlots.some(slot => slot.time === templateTime)
  );
  
  console.log('Time exists in schedule tables:', timeExists);
  if (!timeExists) {
    console.log('Available times in tables:', 
      this.scheduleTables.flatMap(table => table.timeSlots.map(slot => slot.time))
    );
  }
  console.log('=== END TEST ===');
},

// Add this method to test game assignment
testGameAssignment(fieldId, time, date, gameId) {
  console.log('=== TESTING GAME ASSIGNMENT ===');
  console.log('Input:', { fieldId, time, date, gameId });
  
  // Test the computed property
  const computedMap = this.assignedGamesMap;
  const key = `${fieldId}-${time}-${date}`;
  console.log('Computed map key:', key);
  console.log('Computed map result:', computedMap[key]);
  
  // Test template methods
  const assignedGameResult = this.assignedGameFor(fieldId, time, date);
  console.log('assignedGameFor result:', assignedGameResult);
  
  const getAssignedResult = this.getAssignedGame(fieldId, time, this.getDateForComparison(date));
  console.log('getAssignedGame result:', getAssignedResult);
  
  console.log('=== END TEST ===');
},

// Alternative method if API returns complete updated games
updateLocalGamesWithCompleteData(updatedGames) {
  if (!Array.isArray(updatedGames)) {
    console.warn("updatedGames is not an array:", updatedGames);
    return;
  }

  // Clear existing field assignments for this bracket
  this.fieldAssignments = this.fieldAssignments.filter(
    assignment => assignment.game.event_id !== this.eventId
  );

  updatedGames.forEach(updatedGame => {
    // Find and update the game in scheduleData
    const gameIndex = this.scheduleData.findIndex(
      game => game.db_id === updatedGame.db_id || game.id === updatedGame.id
    );

    if (gameIndex !== -1) {
      // Update the entire game object
      this.$set(this.scheduleData, gameIndex, { ...this.scheduleData[gameIndex], ...updatedGame });
      
      const game = this.scheduleData[gameIndex];

      // If the game has scheduling information, add to fieldAssignments
      if (game.assignedFieldId && game.assignedTime && game.assignedDate) {
        this.fieldAssignments.push({
          fieldId: game.assignedFieldId,
          fieldName: game.assignedFieldName,
          time: game.assignedTime,
          date: game.assignedDate,
          game: game,
        });
      }

      // Update the game in bracket display
      this.updateBracketGameDisplay(game);
    }
  });
},
    async getTournamentTeams() {
      this.tournamentTeams = [];

      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getBracketEligibleTournamentTeams?tournament_guid=${this.selectedTournament.guid}`;
        const response = await axios.get(url);

        if (response.data.statusCode === 200) {
          this.tournamentTeams = response.data.data.teams;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to fetch teams:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch teams:", error);
      } finally {
        this.showLoaderSelectedTeams = 0;
        this.isFetchingSelectedTeams = false;
      }
    },
    async addBracket() {
      await this.getTournamentTeams();
      this.$root.$emit("openAddBracketModal", {
        tournamentTeams: this.tournamentTeams,
        selectedTournamentName: this.selectedTournamentName,
        selectedTournamentGuid: this.selectedTournament.guid,
      });
    },

    async getTournamentTeamsForEdit() {
      this.tournamentTeams = [];


      try {
        const url = `${process.env.VUE_APP_API_URL}tournaments/teams/getEligibleTournamentTeamsForEdit?tournament_guid=${this.selectedTournament.guid}&bracket_id=${this.bracketGuid}`;
        const response = await axios.get(url);

        if (response.data.statusCode === 200) {
          this.tournamentTeams = response.data.data.teams;
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, "Error");
          const elem = this.$refs.closeTournamentLineUpModal;
          if (elem) {
            elem.click();
          }
          this.$router.push({ name: "Teams" });
        } else {
          console.error("Failed to fetch teams:", response.data.message);
        }
      } catch (error) {
        console.error("Failed to fetch teams:", error);
      } finally {
        this.showLoaderSelectedTeams = 0;
        this.isFetchingSelectedTeams = false;
      }
    },

    async editBracket() {
      await this.getTournamentTeamsForEdit(),
        this.$root.$emit("openEditBracketModal", {
          tournamentTeams: this.tournamentTeams,
          selectedTournamentName: this.selectedTournamentName,
          selectedTournamentGuid: this.selectedTournament.guid,
          selectedBracketName: this.bracketName,
          selectedBracketDescription: this.bracketDescription,
          selectedBracketTeams: this.bracketTeams,
          bracketGuid: this.bracketGuid,
          association_id: this.association_id,
          bracketId: this.bracketId,
          eventGuid: this.eventGuid,
        });
    },

    assignColorsToDivisions() {
      const staticColors = ["#DFFFEA", "#FFFAEA"]; // greenish, bluish
      const usedColors = new Set(staticColors);
      const uniqueDivisions = [
        ...new Set(this.scheduleData.map((game) => game.division)),
      ];

      uniqueDivisions.forEach((division, index) => {
        if (!this.divisionColorMap[division]) {
          if (index < staticColors.length) {
            this.divisionColorMap[division] = staticColors[index];
          } else {
            let newColor;
            do {
              newColor = this.getRandomPastelColor();
            } while (usedColors.has(newColor)); // avoid duplicates

            usedColors.add(newColor);
            this.divisionColorMap[division] = newColor;
          }
        }
      });
    },

    getRandomPastelColor() {
      const hue = Math.floor(Math.random() * 360);
      return `hsl(${hue}, 70%, 85%)`; // pastel-like
    },
    getDivisionStyle(division) {
      const color = this.divisionColorMap[division];
      return color ? { backgroundColor: color } : {};
    },
    formatTableDate(date) {
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      return date.toLocaleDateString('en-US', options);
    },
    async unlinkGame(game) {
      if (!game) {
        console.warn('Tried to unlink a null game!');
        return;
      }

      const message = `Unlink this game?\n\n${game?.teamA_data?.team_name} vs ${game?.teamB_data?.team_name}`;

      try {
        await this.$confirm(message, 'Confirm Unlink', {
          confirmButtonText: 'Unlink',
          cancelButtonText: 'Cancel',
          type: 'warning',
        });

        const gameIndex = this.scheduleData.findIndex(g => g.db_id === game.db_id);
        if (gameIndex !== -1) {
          const gameToUnlink = this.scheduleData[gameIndex];

          this.$delete(gameToUnlink, 'assignedFieldId');
          this.$delete(gameToUnlink, 'assignedFieldName');
          this.$delete(gameToUnlink, 'assignedTime');
          this.$delete(gameToUnlink, 'assignedDate');

          gameToUnlink.unlink = true;

          await this.updateGame(gameToUnlink);

          this.fieldAssignments = this.fieldAssignments.filter(
            assignment => assignment.game.db_id !== game.db_id
          );

          this.$forceUpdate();
        }
      } catch (err) {
        // This block runs if user cancels or an error occurs
        console.log('Unlink canceled or error occurred', err);
      }
    },
    unlinkGameFromPreviousSlot(game) {
      this.fieldAssignments = this.fieldAssignments.filter(assignment =>
        assignment.game.db_id !== game.db_id
      );
    },
    assignGameToSlot(game, field, timeSlot, date) {
      const assignedIndex = this.scheduleData.findIndex(
        (g) => g.db_id === game.db_id
      );

      if (assignedIndex !== -1) {
        this.unlinkGameFromPreviousSlot(game);

        const originalGame = this.scheduleData[assignedIndex];
        this.$set(originalGame, "assignedFieldId", field.id);
        this.$set(originalGame, "assignedFieldName", field.field_name);
        this.$set(originalGame, "assignedTime", timeSlot.time);
        this.$set(originalGame, "assignedDate", date);

        this.fieldAssignments = this.fieldAssignments.filter(
          (assignment) => assignment.game.db_id !== game.db_id
        );

        this.fieldAssignments.push({
          fieldId: field.id,
          fieldName: field.field_name,
          time: timeSlot.time,
          date: date,
          game: originalGame,
        });

        this.$forceUpdate();
        return originalGame; // ✅ RETURN UPDATED GAME
      } else {
        console.warn("Game not found in scheduleData");
        return game;
      }
    },
    handleAvailableClick(field, time, date, isEditing = false) {
      this.isEditingGame = isEditing;
      const fieldId = typeof field === 'object' ? field.id : field;
      const fullField = typeof field === 'object' ? field : this.allFields.find(f => f.id === field);

      if (!fullField) {
        console.warn("Field object not found for ID:", field);
        return;
      }

      this.selectedFieldForModal = fullField;
      this.selectedTimeForModal = time;
      this.selectedDateForModal = date;
      // this.totalGames = this.teamDistributionSummary.totalGames;

      const game = this.assignedGameFor(fieldId, time, date);
      this.team1Id = game?.teamA || null;
      this.team2Id = game?.teamB || null;
      this.gameType = game?.game_type || 1;
      this.game_id = game?.db_id || null;
      this.umpireId = game?.umpire_id || null;
      this.selectedGameName = game?.game_name || null;
      this.isEditingGame = (this.team1Id && this.team2Id) || (this.gameType === 2 && (!this.team1Id || !this.team2Id));

      if (!game || game.division_id === this.selectedTournament.id) {
        this.callModal(this.selectedTournament);
      }
    },
    callModal(selectedTournament) {
      var tournament = selectedTournament.guid;
      this.$root.$emit("openTournamentAddGameModal", tournament);
    },
    async getEventGamesSchedule() {
      this.showEventHeadingLoader = 1;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}tournaments/getEventGamesSchedule`, { params: { event_guid: this.eventGuid, } }
        );

        if (response.data.statusCode === 200) {
          this.scheduleData = response.data.data.schedule;
          this.summaryData = response.data.data.summary;

          // Assign each game to its slot
          this.scheduleData.forEach(game => {
            if (game.assignedFieldId && game.assignedTime && game.assignedDate) {
              const field = {
                id: game.assignedFieldId,
                field_name: game.assignedFieldName
              };

              const timeSlot = {
                time: game.assignedTime
              };

              this.assignGameToSlot(game, field, timeSlot, game.assignedDate);
            }
          });
          this.assignColorsToDivisions();
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
      } finally {
        this.$root.$emit("divisionPaginationLoaded");
        this.showEventHeadingLoader = 0;
      }
    },
    generateTimeSlots(startTime, intervalMinutes, endTime) {
      const slots = [];

      // Helper function to convert "HH:MM AM/PM" → total minutes
      const convertToMinutes = (timeStr) => {
        const [time, period] = timeStr.split(' ');
        const [hours, minutes] = time.split(':').map(Number);

        let hour24 = hours;
        if (period === 'PM' && hours !== 12) hour24 += 12;
        if (period === 'AM' && hours === 12) hour24 = 0;

        return hour24 * 60 + minutes;
      };

      const startMinutes = convertToMinutes(startTime);
      const endMinutes = convertToMinutes(endTime); // ⬅️ using dynamic endTime

      for (let currentMinutes = startMinutes; currentMinutes < endMinutes; currentMinutes += intervalMinutes) {
        const hour = Math.floor(currentMinutes / 60);
        const minute = currentMinutes % 60;

        const displayHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
        const displayPeriod = hour >= 12 ? 'PM' : 'AM';
        const timeString = `${displayHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${displayPeriod}`;

        slots.push({
          time: timeString,
          minutes: currentMinutes
        });
      }

      return slots;
    },
    isDateWithinTournamentRange(date) {
      if (!this.selectedTournament) return false;

      const start = new Date(this.selectedTournament.startDateForField);
      const end = new Date(this.selectedTournament.endDateForField);

      const cellDate = new Date(date);

      // Remove time part for comparison
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      cellDate.setHours(0, 0, 0, 0);

      return cellDate >= start && cellDate <= end;
    },
    getParkField(searchQuery) {
      // this.isLoadingField = true;
      this.showFieldsLoader = 1
      axios
        .get(`${process.env.VUE_APP_API_URL}getAllEventParkFields?event_id=${this.eventId}&search=${searchQuery || ""}`)
        .then((response) => {
          const parks = response.data.data.parks || [];

          // Flatten all fields and filter out "Add field"
          const allFields = parks
            .flatMap(park => park.fields || [])
            .filter(field => field.field_name && field.field_name.toLowerCase() !== "add field");

          this.allFields = allFields;
          this.selectedFields = [...allFields];
          // this.isLoadingField = false;
          this.showFieldsLoader = 0
          this.scrollToDivisionStartDate();
        });
    },
    // getAssignedGame(fieldId, time, date) {
    //   const key = `${fieldId}-${time}-${date}`;
    //   return this.assignedGamesMap[key] || null;
    // },
    assignedGameFor(fieldId, time, date) {
      return this.getAssignedGame(fieldId, time, this.getDateForComparison(date));
    },
    getDateForComparison(date) {
      if (date instanceof Date) {
        // Use local time instead of UTC
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return date;
    },
    scrollToDivisionStartDate() {
      if (!this.selectedTournament || !this.selectedTournament.startDateForField) return;

      const startDate = this.selectedTournament.startDateForField; // e.g., "2025-06-12"
      const refName = 'table-' + startDate;

      // Vue 2: v-for with ref returns an array
      setTimeout(() => {
        const ref = this.$refs[refName];
        const targetTable = Array.isArray(ref) ? ref[0] : ref;

        if (targetTable && typeof targetTable.scrollIntoView === 'function') {
          targetTable.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
        } else {
          console.warn("scrollIntoView failed", targetTable);
        }
      }, 100);
    },
    goEventListing() {
      this.$router.push({ name: "AssociationSingleEventDetail", params: { id: this.eventGuid } });
    },
    handleBackClick() {
      this.$router.push({ name: "PoolPlayGenerator", params: { id: this.eventGuid } });
    },
    async getBracketData() {
      this.bracketsLoader = 1;
      this.bracketGuid = this.$route.params.id;
      await axios
        .get(`${process.env.VUE_APP_API_URL}tournaments/brackets/getBracketDetails`, {
          params: {
            bracket_guid: this.bracketGuid,
            association_id: localStorage.getItem("association_id"),
          }
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            this.bracketGames = response.data.data.games;
            this.eventGuid = response.data.data.event_tournament.event.guid;
            this.selectedTournament = response.data.data.event_tournament;
            this.selectedTournamentName = response.data.data.event_tournament.tournamentName;
            this.bracketName = response.data.data.bracket_name;
            console.log("response", response)
            this.bracketDescription = response.data.data.bracket_description;
            this.bracketId = response.data.data.id;
            this.bracketTeams = response.data.data.bracket_teams;
            this.teamCounts = response.data.data.teamCounts;
            this.bracketFormat = response.data.data.event_tournament.bracket_format_info?.bracket_name
              ?? response.data.data.event_tournament.event?.bracket_format?.bracket_name;
            this.processBracketData();
            this.bracketsLoader = 0;
          } else {
            this.errorMessage = response.data.message;
            this.bracketsLoader = 0;
          }
        });
    },

    async TournamentsDetailData() {
      // var eventGuid = this.eventGuid;
      this.showEventHeadingLoader = 1;
      this.showLoaderTournament = 1;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}event/tournamentListForAdminEvents?page=${this.divisionPage}`,
          { event_guid: this.eventGuid }
        );

        if (response.data.statusCode === 200) {

          this.tournamentsData = response.data.data.eventTournaments.data;
          this.events = response.data.data.teamEventData;
          this.startDate = response.data.data.teamEventData.exactStartDate;
          this.allDay = response.data.data.teamEventData.allDay;
          this.endDate = response.data.data.teamEventData.exactEndDate;
          this.eventId = response.data.data.teamEventData.id;
          this.eventName = response.data.data.teamEventData.eventName;
          this.startTime = this.allDay === "true" ? "12:00 AM" : response.data.data.teamEventData.exactStartTime;
          this.endTime = this.allDay === "true" ? "11:59 PM" : response.data.data.teamEventData.exactEndTime;
          this.tournament_time = Number(response.data.data.teamEventData?.time_interval ?? 30);
          this.association_id = response.data.data?.user_association_role?.association_id;

          this.$nextTick(() => {
            if (this.sortedTournaments.length > 0 && !this.selectedTournamentGuid) {
              const firstSortedTournament = this.sortedTournaments[0];
              this.selectTournament(firstSortedTournament);
            }
          });
        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });

          this.showLoader = 0; // Hide loader
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderTournament = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderTournament = 0;
      } finally {
        this.showEventHeadingLoader = 0;
        this.showLoaderTournament = 0;
        this.$root.$emit("divisionPaginationLoaded");
      }
    },

    formatAssignedDate(date) {
      if (!date) return '';

      const d = new Date(date);

      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const dayName = dayNames[d.getDay()];       // getDay() returns 0 (Sun) to 6 (Sat)
      const month = monthNames[d.getMonth()];     // getMonth() returns 0 to 11
      const day = d.getDate();                    // getDate() returns 1 to 31

      return `${dayName} ${month} ${day}`;
    },

    onDragStart(game, event) {
      // Use originalGame if it exists, else use game itself
      const draggedData = game.originalGame || game;

      this.draggedGame = draggedData;

      // Save normalized game to dataTransfer
      event.dataTransfer.setData('game', JSON.stringify(draggedData));

      // Get the game name
      const gameName = draggedData.gameName || game.gameName || '';

      // Create custom drag image
      const dragImage = document.createElement('div');
      dragImage.textContent = gameName;
      dragImage.style.position = 'absolute';
      dragImage.style.top = '-9999px';
      dragImage.style.padding = '6px 12px';
      dragImage.style.backgroundColor = '#ffffff'; // white background
      dragImage.style.color = '#000000';           // black text
      dragImage.style.border = '1px solid #000000';// black border
      dragImage.style.fontSize = '14px';
      dragImage.style.borderRadius = '4px';
      dragImage.style.pointerEvents = 'none';
      dragImage.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)';
      document.body.appendChild(dragImage);

      // Set drag image
      event.dataTransfer.setDragImage(dragImage, 0, 0);

      // Clean up
      setTimeout(() => {
        document.body.removeChild(dragImage);
      }, 0);
    },

    handleDrop(field, timeSlot, date, event) {
      if (!this.isDateWithinTournamentRange(date)) {
        // Optionally show alert or toast
        this.$alert("Cannot drop games on invalid date.");
        return;
      }
      this.onDrop(field, timeSlot, date, event);
    },

    onDrop(field, timeSlot, date, event) {
      event.preventDefault();

      let rawGame = this.draggedGame || JSON.parse(event.dataTransfer.getData('game'));

      // ✅ Normalize: use originalGame if present
      const gameData = rawGame.originalGame || rawGame;
      if (!gameData) return;

      const formattedDate = this.getDateForComparison(date);

      // 🛠 Optional Conflict Checks
      const existingGame = this.getAssignedGame(field.id, timeSlot.time, formattedDate);
      if (existingGame && (existingGame.db_id || existingGame.id) !== (gameData.db_id || gameData.id)) {
        this.showConflictAlert(existingGame, field, timeSlot, formattedDate);
        return;
      }

      const conflictingGame = this.isTimeSlotOccupiedOnOtherField(field.id, timeSlot.time, formattedDate, gameData);
      if (conflictingGame) {
        this.showOtherFieldConflictAlert(conflictingGame, field, timeSlot, formattedDate);
        return;
      }

      const updatedGame = this.assignGameToSlot(gameData, field, timeSlot, formattedDate);
      this.updateGame(updatedGame); // ✅ always gets the updated game
    },


    showConflictAlert(existingGame, field, timeSlot, date) {
      const message = `This slot is already occupied!\n\nExisting Game:\n${existingGame?.teamA_data?.team_name || existingGame?.team1} vs ${existingGame?.teamB_data?.team_name || existingGame?.team2}\nDivision: ${existingGame.division}\nField: ${field.field_name}\nTime: ${timeSlot.time} - ${date}\n\nPlease choose a different slot.`;
      this.$alert(message);
    },

    showOtherFieldConflictAlert(existingGame, field, timeSlot, date) {
      const formattedDateTime = this.formatDateTime(date, timeSlot.time);
      const fieldName = existingGame.assignedFieldName || 'N/A';
      const message = `One of the teams is already playing at this time on another field!\n\nExisting Game:\n${existingGame?.teamA_data?.team_name || existingGame?.team1} vs ${existingGame?.teamB_data?.team_name || existingGame?.team2}\nDivision: ${existingGame.division}\nField: ${fieldName}\nTime: ${formattedDateTime}\n\nA team cannot play on multiple fields at the same time.`;
      this.$alert(message);
    },

    async updateGame(game) {
      // Start the loader and disable the game controls
      this.showLoaderGame = true;
      this.isDisabledGame = true;

      const formData = new FormData();
      if (game?.teamA) {
        formData.append("team_1_id", game.teamA);
      }

      if (game?.teamB) {
        formData.append("team_2_id", game.teamB);
      }
      formData.append("event_id", this.selectedTournament?.event_id);
      formData.append("game_type", game?.game_type);

      // Handle unlink case
      if (game.unlink) {
        formData.append("start_date", "");
        formData.append("start_time", "");
        formData.append("field_id", "");

        // Clear the assignment fields locally immediately
        game.assignedFieldId = null;
        game.assignedFieldName = null;
        game.assignedTime = null;
        game.assignedDate = null;
      } else {
        formData.append("start_date", game?.assignedDate);
        formData.append("start_time", game?.assignedTime);
        formData.append("field_id", game?.assignedFieldId);
      }

      if (game && (game.db_id)) {
        formData.append("game_id", game.db_id);
      } else {
        console.error("No game ID found to update!");
        this.showLoaderGame = false;
        this.isDisabledGame = false;
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/editTournamentGame`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Game updated successfully", response.data);

        // Update the game in scheduleData
        const index = this.scheduleData.findIndex(g => g.db_id === game.db_id);
        if (index !== -1) {
          this.scheduleData[index] = { ...this.scheduleData[index], ...game };
        }

        // Remove from fieldAssignments if unlinked
        if (game.unlink) {
          this.fieldAssignments = this.fieldAssignments.filter(
            assignment => assignment.game.db_id !== game.db_id
          );
          delete game.unlink; // Remove the unlink flag after processing
        }

        // Update the game in bracket display
        this.updateBracketGameDisplay(game);

        // Force Vue to update the view
        this.$forceUpdate();

      } catch (error) {
        console.error("Error updating game", error);
      } finally {
        this.showLoaderGame = false;
        this.isDisabledGame = false;
      }
    },

    // Helper method to update game in bracket display
    updateBracketGameDisplay(game) {
      // Update in single elimination rounds
      this.singleEliminationRounds.forEach(round => {
        round.forEach(match => {
          if (match && match.originalGame && match.originalGame.db_id === game.db_id) {
            match.originalGame = { ...match.originalGame, ...game };
          }
        });
      });

      // Update in double elimination rounds
      this.winnerBracketRounds.forEach(round => {
        round.forEach(match => {
          if (match && match.originalGame && match.originalGame.db_id === game.db_id) {
            match.originalGame = { ...match.originalGame, ...game };
          }
        });
      });

      this.loserBracketRounds.forEach(round => {
        round.forEach(match => {
          if (match && match.originalGame && match.originalGame.db_id === game.db_id) {
            match.originalGame = { ...match.originalGame, ...game };
          }
        });
      });

      this.grandFinalRounds.forEach(match => {
        if (match && match.originalGame && match.originalGame.db_id === game.db_id) {
          match.originalGame = { ...match.originalGame, ...game };
        }
      });
    },

    isTimeSlotOccupiedOnOtherField(fieldId, time, date, currentGame) {
      for (const assignment of this.fieldAssignments) {
        if (
          assignment.fieldId !== fieldId && // different field
          assignment.time === time &&
          assignment.date === date
        ) {
          // Check if either team from current game is playing in the other assignment
          const otherGame = assignment.game;
          if (
            currentGame.db_id !== otherGame.db_id && // not the same game
            (
              currentGame.teamA === otherGame.teamA ||
              currentGame.teamA === otherGame.teamB ||
              currentGame.teamB === otherGame.teamA ||
              currentGame.teamB === otherGame.teamB
            )
          ) {
            return assignment.game;
          }
        }
      }
      return null;
    },

    formatDateRange(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const startDateString = start.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const endDateString = end.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
      const startYear = start.getFullYear();
      const endYear = end.getFullYear();

      if (startYear === endYear) {
        return `${startDateString} to ${endDateString}, ${startYear}`;
      } else {
        return `${startDateString}, ${startYear} to ${endDateString}, ${endYear}`;
      }
    },

    processBracketData() {
      if (!this.bracketGames || this.bracketGames.length === 0) return;

      // Determine bracket type from games
      const bracketTypes = this.bracketGames.map(game => game.bracket_type);
      const hasDoubleElimination = bracketTypes.includes('winner') || bracketTypes.includes('loser') || bracketTypes.includes('grand_final');

      this.bracketType = hasDoubleElimination ? 'double' : 'single';

      if (this.bracketType === 'single') {
        this.processSingleEliminationBracket();
      } else {
        this.processDoubleEliminationBracket();
      }
    },

    // Add this method to calculate the minimum top position across all rounds
    adjustPositionsWithOffset(rounds, offset) {
      rounds.forEach(round => {
        round.forEach(match => {
          if (match) {
            match.top += offset;
          }
        });
      });
    },

    // Helper method to calculate minimum top position across all rounds
    calculateMinTopPosition(rounds) {
      let minTop = Infinity;

      rounds.forEach(round => {
        round.forEach(match => {
          if (match && match.top < minTop) {
            minTop = match.top;
          }
        });
      });

      return minTop === Infinity ? 0 : minTop;
    },

    processSingleEliminationBracket() {
      // Group games by round_number (only for single bracket_type)
      const roundsMap = {};
      this.bracketGames
        .filter(game => game.bracket_type === 'single')
        .forEach(game => {
          if (!roundsMap[game.round_number]) {
            roundsMap[game.round_number] = [];
          }
          roundsMap[game.round_number].push(this.formatGameData(game));
        });

      // Convert to array and sort by round number
      const rounds = Object.keys(roundsMap)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map(roundNum => {
          return roundsMap[roundNum].sort((a, b) => a.position - b.position);
        });

      // Add spacing to rounds starting from 50px (consistent with double elimination)
      this.addSpacingToRounds(rounds, 50);

      // Check and adjust positioning to ensure it starts at 50px
      const minTop = this.calculateMinTopPosition(rounds);
      if (minTop !== 50) {
        const offset = 50 - minTop;
        this.adjustPositionsWithOffset(rounds, offset);
      }

      this.singleEliminationRounds = rounds;
    },

    processDoubleEliminationBracket() {
      // Separate games by bracket_type
      const winnerGames = this.bracketGames.filter(game => game.bracket_type === 'winner');
      const loserGames = this.bracketGames.filter(game => game.bracket_type === 'loser');
      const grandFinalGames = this.bracketGames.filter(game => game.bracket_type === 'grand_final');

      // Process winner bracket
      this.winnerBracketRounds = this.groupGamesByRounds(winnerGames.map(game => this.formatGameData(game)));
      this.addSpacingToRounds(this.winnerBracketRounds, 50); // Start from 50px for winner bracket

      // Check and adjust winner bracket positioning to ensure it starts at 50px
      const winnerMinTop = this.calculateMinTopPosition(this.winnerBracketRounds);
      if (winnerMinTop !== 50) {
        const offset = 50 - winnerMinTop;
        this.adjustPositionsWithOffset(this.winnerBracketRounds, offset);
      }

      // Calculate winner bracket height
      this.winnerBracketHeight = this.calculateRoundsHeight(this.winnerBracketRounds) + 40; // Add padding

      // Process loser bracket - keep positioning independent from winner bracket
      this.loserBracketRounds = this.groupGamesByRounds(loserGames.map(game => this.formatGameData(game)));
      this.addSpacingToRounds(this.loserBracketRounds, 50); // Start from 50px for loser bracket

      // Check and adjust loser bracket positioning to ensure it starts at 50px
      const loserMinTop = this.calculateMinTopPosition(this.loserBracketRounds);
      if (loserMinTop !== 50) {
        const offset = 50 - loserMinTop;
        this.adjustPositionsWithOffset(this.loserBracketRounds, offset);
      }

      // Calculate loser bracket height
      this.loserBracketHeight = this.calculateRoundsHeight(this.loserBracketRounds) + 40; // Add padding

      // Process grand final with proper connection to winner bracket final
      if (grandFinalGames.length > 0) {
        const formattedGrandFinal = grandFinalGames.map(game => this.formatGameData(game));

        // Find the final game of winner bracket (last round, last game)
        let winnerFinalGame = null;
        if (this.winnerBracketRounds.length > 0) {
          const lastWinnerRound = this.winnerBracketRounds[this.winnerBracketRounds.length - 1];
          if (lastWinnerRound.length > 0) {
            winnerFinalGame = lastWinnerRound[0]; // Usually there's only one final game
          }
        }

        // Set position and height for each grand final match
        formattedGrandFinal.forEach(match => {
          if (winnerFinalGame) {
            // Calculate the center of the winner bracket final game
            const winnerFinalCenter = winnerFinalGame.top + (winnerFinalGame.matchHeight / 2);

            // Calculate the bottom of the winner bracket final game
            const winnerFinalBottom = winnerFinalGame.top + winnerFinalGame.matchHeight;

            // Set grand final to start at winner bracket final center
            match.top = winnerFinalCenter;

            // Set grand final height to extend from center to below the winner bracket final
            // Adding extra height to extend below the winner bracket final
            const extensionHeight = winnerFinalGame.matchHeight / 2; // Half height of winner final
            match.matchHeight = (winnerFinalBottom - winnerFinalCenter) + extensionHeight;
          } else {
            // Fallback positioning if no winner final game found
            match.top = 50;
            match.matchHeight = 50;
          }
        });

        this.grandFinalRounds = formattedGrandFinal;
      } else {
        this.grandFinalRounds = [];
      }
    },

    groupGamesByRounds(games) {
      const roundsMap = {};
      games.forEach(game => {
        if (!roundsMap[game.roundNumber]) {
          roundsMap[game.roundNumber] = [];
        }
        roundsMap[game.roundNumber].push(game);
      });

      return Object.keys(roundsMap)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map(roundNum => {
          return roundsMap[roundNum].sort((a, b) => a.position - b.position);
        });
    },

    formatGameData(game) {
      // Parse source teams
      const sourceTeam1 = this.parseSourceTeam(game.source_team_1);
      const sourceTeam2 = this.parseSourceTeam(game.source_team_2);

      // Helper function to get team display name
      const getTeamDisplayName = (teamData, sourceTeam) => {
        // If team data exists, show team name
        if (teamData?.team?.team_name) {
          return teamData.team.team_name;
        }

        // If source team is from a game, show "Winner of" or "Loser of"
        if (sourceTeam.type === 'game' && sourceTeam.id) {
          const sourceGame = this.bracketGames.find(g => g.id === sourceTeam.id);
          if (sourceGame) {
            const position = sourceTeam.position || 'winner'; // default to winner if position not specified
            const prefix = position === 'winner' ? 'Winner of' : 'Loser of';
            return `${prefix} ${sourceGame.game_name}`;
          }
        }

        // Return empty string if no team data and no source game
        return '';
      };

      // Helper function to get seed display
      const getSeedDisplay = (teamData, sourceTeam) => {
        // If team data exists, show seed
        if (teamData?.seed_count) {
          return teamData.seed_count;
        }

        // If source team is from a seed, show the seed number
        if (sourceTeam.type === 'seed' && sourceTeam.id) {
          return sourceTeam.id;
        }

        // Return empty string for game sources (no seed)
        return '';
      };

      // Determine if teams are winners or losers
      // Check if game has a winner and if team IDs match the winner ID
      const isGameFinished = !!game.winner_id;

      // Try both possible ID comparisons
      // First try comparing with tournament team ID (game.team_one.id)
      let isTeam1Winner = isGameFinished && game.team_one?.id === game.winner_id;
      let isTeam2Winner = isGameFinished && game.team_two?.id === game.winner_id;

      // If that didn't work, try comparing with actual team ID (game.team_one.team.id)
      if (isGameFinished && !isTeam1Winner && !isTeam2Winner) {
        isTeam1Winner = game.team_one?.team?.id === game.winner_id;
        isTeam2Winner = game.team_two?.team?.id === game.winner_id;
      }

      return {
        id: game.id,
        gameName: `#${game.game_name}` || `Game ${game.id}`,
        roundNumber: game.round_number,
        position: game.position,
        team1: getTeamDisplayName(game.team_one, sourceTeam1),
        team2: getTeamDisplayName(game.team_two, sourceTeam2),
        seed1: getSeedDisplay(game.team_one, sourceTeam1),
        seed2: getSeedDisplay(game.team_two, sourceTeam2),
        top: 0,
        matchHeight: 50,
        originalGame: game,
        isGameFinished: isGameFinished,
        isTeam1Winner: isTeam1Winner,
        isTeam2Winner: isTeam2Winner,
        winner_id: game.winner_id
      };
    },

    parseSourceTeam(sourceTeamString) {
      try {
        if (!sourceTeamString) return { type: null, id: null, position: null };
        const parsed = JSON.parse(sourceTeamString);
        return {
          type: parsed.type,
          id: parsed.id,
          position: parsed.position || null
        };
      } catch (e) {
        return { type: null, id: null, position: null };
      }
    },

    calculateRoundsHeight(rounds) {
      if (!rounds || rounds.length === 0) return 0;

      let maxHeight = 0;

      rounds.forEach(round => {
        round.forEach(match => {
          const bottomPosition = match.top + match.matchHeight;
          if (bottomPosition > maxHeight) {
            maxHeight = bottomPosition;
          }
        });
      });

      return maxHeight;
    },

    addSpacingToRounds(rounds, offsetY = 0) {
      const matchHeight = 50;
      const verticalGap = 50;

      if (rounds.length === 0) return;

      // Position first round matches based on API position, not array index
      rounds[0].forEach((match) => {
        // Use API position field instead of array index
        const apiPosition = match.position || 0; // Fallback to 0 if position not provided
        match.top = offsetY + (apiPosition - 1) * (matchHeight + verticalGap); // API position is 1-based
        match.matchHeight = matchHeight;
      });

      // Position subsequent rounds
      for (let r = 1; r < rounds.length; r++) {
        const prevRound = rounds[r - 1];
        const currRound = rounds[r];

        // First pass: Position matches based on their relationships
        for (let i = 0; i < currRound.length; i++) {
          const currentMatch = currRound[i];

          // Skip if match doesn't exist
          if (!currentMatch) continue;

          // Find source games that feed into this match
          const sourceGames = this.findSourceGames(currentMatch, prevRound);

          if (sourceGames.length >= 2) {
            // Position between the two source games
            const game1 = sourceGames[0];
            const game2 = sourceGames[1];

            // Sort games by their vertical position
            const sortedGames = [game1, game2].sort((a, b) => a.top - b.top);
            const upperGame = sortedGames[0];
            const lowerGame = sortedGames[1];

            // Calculate centers of source games
            const upperCenter = upperGame.top + upperGame.matchHeight / 2;
            const lowerCenter = lowerGame.top + lowerGame.matchHeight / 2;

            // Position current match to span from upper game center to lower game center
            const startY = upperCenter;
            const endY = lowerCenter;
            const height = Math.max(matchHeight, endY - startY);

            currentMatch.top = startY - (height - (endY - startY)) / 2;
            currentMatch.matchHeight = height;

          } else if (sourceGames.length === 1) {
            // Position based on single source game
            const sourceGame = sourceGames[0];
            const sourceCenter = sourceGame.top + sourceGame.matchHeight / 2;

            // Set the current match to have the same height as the source game
            currentMatch.matchHeight = sourceGame.matchHeight;

            // Determine direction to extend based on available space
            const extendDirection = this.getExtensionDirection(currentMatch, currRound, i, sourceGame, prevRound);

            if (extendDirection === 'up') {
              currentMatch.top = sourceCenter - sourceGame.matchHeight;
            } else if (extendDirection === 'down') {
              currentMatch.top = sourceCenter;
            } else {
              currentMatch.top = sourceCenter - sourceGame.matchHeight / 2;
            }

          } else {
            // Fallback: Use API position if available, otherwise use traditional pairing
            if (currentMatch.position) {
              // Respect API position for matches without clear source games
              const apiPosition = currentMatch.position;

              // Calculate proper spacing considering previous matches in this round
              let calculatedTop = offsetY + (apiPosition - 1) * (matchHeight + verticalGap);

              // Check if we need to adjust based on previous matches in this round
              const prevMatchesInRound = currRound.slice(0, i).filter(m => m != null);
              if (prevMatchesInRound.length > 0) {
                // Find the last positioned match
                const lastMatch = prevMatchesInRound[prevMatchesInRound.length - 1];
                const lastMatchBottom = lastMatch.top + Math.max(lastMatch.matchHeight, matchHeight);
                const minRequiredTop = lastMatchBottom + verticalGap;

                // Use the maximum of calculated position and minimum required position
                calculatedTop = Math.max(calculatedTop, minRequiredTop);
              }

              currentMatch.top = calculatedTop;
              currentMatch.matchHeight = matchHeight;
            } else {
              // Traditional pairing logic as fallback
              const match1Index = i * 2;
              const match2Index = i * 2 + 1;

              const match1 = prevRound[match1Index];
              const match2 = prevRound[match2Index];

              if (match1 && match2) {
                const center1 = match1.top + matchHeight / 2;
                const center2 = match2.top + matchHeight / 2;

                const upperCenter = Math.min(center1, center2);
                const lowerCenter = Math.max(center1, center2);
                const height = Math.max(matchHeight, lowerCenter - upperCenter);

                currentMatch.top = upperCenter - (height - (lowerCenter - upperCenter)) / 2;
                currentMatch.matchHeight = height;
              } else if (match1) {
                currentMatch.top = match1.top;
                currentMatch.matchHeight = matchHeight;
              } else {
                // Position with standard spacing if no source games
                currentMatch.top = offsetY + i * (matchHeight + verticalGap);
                currentMatch.matchHeight = matchHeight;
              }
            }
          }
        }

        // MODIFIED: Only resolve collisions if they don't disturb API positioning
        this.resolveCollisionsRespectingPositions(currRound, verticalGap, matchHeight);
      }
    },

    // Modified collision resolution that respects API positions and maintains proper gaps
    resolveCollisionsRespectingPositions(matches, minGap, defaultHeight) {
      // Filter out null/undefined matches
      const validMatches = matches.filter(match => match != null);

      if (validMatches.length <= 1) return;

      // Sort by current vertical position to check for overlaps
      validMatches.sort((a, b) => a.top - b.top);

      // Ensure minimum gaps between all matches
      for (let i = 1; i < validMatches.length; i++) {
        const currentMatch = validMatches[i];
        const prevMatch = validMatches[i - 1];

        // Use the larger of the two match heights for gap calculation
        const prevMatchHeight = Math.max(prevMatch.matchHeight, defaultHeight);
        const prevBottom = prevMatch.top + prevMatchHeight;
        const currentTop = currentMatch.top;

        // Calculate required minimum gap
        const requiredGap = minGap;
        const actualGap = currentTop - prevBottom;

        // If gap is insufficient, adjust position
        if (actualGap < requiredGap) {
          const adjustment = requiredGap - actualGap;

          console.log(`Adjusting gap between matches: current gap ${actualGap}px, required ${requiredGap}px`);

          // If current match has API position, try to move previous matches up first
          if (currentMatch.position) {
            // Try to move previous match up if possible
            if (!prevMatch.position) {
              const newPrevTop = currentTop - prevMatchHeight - requiredGap;
              if (newPrevTop >= 0) {
                prevMatch.top = newPrevTop;
                continue;
              }
            }
            // If can't move previous match, move current match down minimally
            currentMatch.top += adjustment;
          }
          // If previous match has API position, move current match down
          else if (prevMatch.position) {
            currentMatch.top = prevBottom + requiredGap;
          }
          // If neither has API position, move current match to maintain gap
          else {
            currentMatch.top = prevBottom + requiredGap;
          }
        }
      }
    },

    // NEW METHOD: Check if two games overlap
    gamesOverlap(game1, game2, minGap) {
      const game1Bottom = game1.top + game1.matchHeight;
      const game2Bottom = game2.top + game2.matchHeight;

      // Check if games overlap vertically (with minimum gap requirement)
      return !(game1Bottom + minGap <= game2.top || game2Bottom + minGap <= game1.top);
    },

    // NEW METHOD: Move game based on its position key
    moveGameBasedOnPosition(hiddenGame, connectedGame, minGap) {
      const connectedGameTop = connectedGame.top;
      const connectedGameBottom = connectedGame.top + connectedGame.matchHeight;

      // Add extra space for game number label (22px based on CSS)
      const gameNumberSpace = 22;
      const totalGap = minGap + gameNumberSpace;

      // Use position key to determine direction
      // Lower position numbers go up, higher position numbers go down
      if (hiddenGame.position < connectedGame.position) {
        // Move hidden game above the connected game
        // Account for: hiddenGame height + gap + space for game number
        const requiredSpace = hiddenGame.matchHeight + totalGap;
        hiddenGame.top = connectedGameTop - requiredSpace;

        console.log(`Moving G${hiddenGame.gameName} up:`, {
          hiddenGamePosition: hiddenGame.position,
          connectedGamePosition: connectedGame.position,
          connectedGameTop: connectedGameTop,
          requiredSpace: requiredSpace,
          newTop: hiddenGame.top
        });

        // If this pushes the game to negative position, move it to 0
        if (hiddenGame.top < 0) {
          console.log(`G${hiddenGame.gameName} pushed to negative, setting to 0`);
          hiddenGame.top = 0;
        }
      } else {
        // Move hidden game below the connected game
        hiddenGame.top = connectedGameBottom + totalGap;

        console.log(`Moving G${hiddenGame.gameName} down:`, {
          hiddenGamePosition: hiddenGame.position,
          connectedGamePosition: connectedGame.position,
          connectedGameBottom: connectedGameBottom,
          newTop: hiddenGame.top
        });
      }
    },

    // NEW METHOD: Check if a game has source connections (linked to previous round)
    hasSourceConnection(game) {
      // Find the game data from bracketGames
      const gameData = this.bracketGames.find(g => g.id === game.id);

      if (!gameData) return false;

      // Parse source teams
      const sourceTeam1 = this.parseSourceTeam(gameData.source_team_1);
      const sourceTeam2 = this.parseSourceTeam(gameData.source_team_2);

      // Has connection if either source team comes from a previous game
      const hasSourceGame1 = sourceTeam1.type === 'game' && sourceTeam1.id;
      const hasSourceGame2 = sourceTeam2.type === 'game' && sourceTeam2.id;

      return hasSourceGame1 || hasSourceGame2;
    },

    // Add this method to determine extension direction based on available space
    getExtensionDirection(currentMatch, currentRound, matchIndex, sourceGame, prevRound) {
      // Find the position of source game in previous round
      const sourceGameIndex = prevRound.findIndex(game => game.id === sourceGame.id);

      // Check if there are games above and below the source game
      const hasGameAbove = sourceGameIndex > 0;
      const hasGameBelow = sourceGameIndex < prevRound.length - 1;

      // If source game is at the top, extend upward (toward empty space)
      if (!hasGameAbove) {
        return 'up';
      }

      // If source game is at the bottom, extend downward (toward empty space)
      if (!hasGameBelow) {
        return 'down';
      }

      // If source game is in the middle, determine based on current match position
      // Even indices extend up, odd indices extend down
      return matchIndex % 2 === 0 ? 'up' : 'down';
    },

    // Updated findSourceGames method to handle both winner and loser brackets
    findSourceGames(currentMatch, prevRound) {
      const sourceGames = [];

      // Get the current game data from bracketGames
      const currentGameData = this.bracketGames.find(game => game.id === currentMatch.id);

      if (!currentGameData) return sourceGames;

      // Parse source teams to find which games they come from
      const sourceTeam1 = this.parseSourceTeam(currentGameData.source_team_1);
      const sourceTeam2 = this.parseSourceTeam(currentGameData.source_team_2);

      // Find source games in the previous round
      if (sourceTeam1.type === 'game' && sourceTeam1.id) {
        const sourceGame = prevRound.find(game => game.id === sourceTeam1.id);
        if (sourceGame) {
          sourceGames.push(sourceGame);
        }
      }

      if (sourceTeam2.type === 'game' && sourceTeam2.id) {
        const sourceGame = prevRound.find(game => game.id === sourceTeam2.id);
        if (sourceGame && !sourceGames.find(g => g.id === sourceGame.id)) {
          sourceGames.push(sourceGame);
        }
      }

      return sourceGames;
    },

    // Add this method to determine if a match is in upper or lower bracket position
    isUpperBracketPosition(currentRound, matchIndex) {
      const totalMatches = currentRound.length;
      const midPoint = totalMatches / 2;

      return matchIndex < midPoint;
    },
  },
};
</script>

<style scoped>
.availability-status.invalid {
  padding: 15px 10px;
  background-color: #f0f2f5 !important;
}
.current-division {
  background-color: #dfffea !important;
  border: 0.5px solid #17c653 !important;
}

.assigned.other-division {
  background-color: #f0f2f5 !important;
  border: 0.5px solid #b9c6d3 !important;
}

.assigned.other-division.umpire-assigned {
  background-color: #e5f2fe !important;
  border: 0.5px solid #7fc0f9 !important;
}

.assigned.other-division.no-umpire {
  background-color: #ffffff !important;
  border: 0.5px solid #b9c6d3 !important;
}

.current-division.umpire-assigned {
  background-color: #e5f2fe !important;
  border: 0.5px solid #7fc0f9 !important;
}

.current-division.no-umpire {
  background-color: #ffffff !important;
  border: 0.5px solid #b9c6d3 !important;
}

.field-cell.no-game,
.field-cell.invalid {
  background-color: #f0f2f5 !important;
  cursor: not-allowed !important;
}

.field-cell.no-game,
.field-cell.invalid {
  background-color: #f0f2f5 !important;
  cursor: not-allowed !important;
}
</style>